import React from 'react';
import * as Yup from 'yup';

export const SaleOrderDeliveryValidatorSchema = Yup.object().shape({
    amount: Yup.number().nullable(true),
    weight: Yup.number().nullable(true),
    deliverySystem: Yup.object().required('required'),
    status: Yup.object().required('required')
});